import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import SvgChevronright from '@common/icon/SvgChevronright';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { DONATION_ROUTES } from '@/constants';
interface EmptyStateProps {
  className?: string;
}
export const EmptyState = t0 => {
  const $ = _c(7);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col items-center justify-center gap-16 py-80", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("text-center font-400 text-Gray-550 typo-body2", "mobile-tablet:typo-body3");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className={t2}>아직 준비된 정보가 없어요.<br />다른 지자체의 답례품을 먼저 둘러보세요.</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button dimensions="H48" theme="sub-line" asChild={true} className="rounded-small"><CustomLink className="gap-6" href={DONATION_ROUTES.GIFTS.pathname} aria-label={"\uB2F5\uB840\uD488 \uBAA9\uB85D \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"}>답례품 보러가기<SvgChevronright className="size-16 text-Gray-600" /></CustomLink></Button>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1) {
    t5 = <section className={t1}>{t3}{t4}</section>;
    $[5] = t1;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};